/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsAppointment } from "../../entities/models/Appointment";
import { z } from "zod/v4";

export const modelsAppointmentSchema = z.object({
    "actual_end_time": z.optional(z.string()),
"actual_start_time": z.optional(z.string()),
"barber_avatar_url": z.optional(z.string()),
"barber_id": z.optional(z.int()),
"barber_name": z.optional(z.string()),
"booking_type": z.optional(z.string()),
"called_at": z.optional(z.string()),
"client_display_name": z.optional(z.string()),
"client_phone": z.optional(z.string()),
"created_at": z.optional(z.string()),
"estimated_end_time": z.optional(z.string()),
"estimated_start_time": z.optional(z.string()),
"group_role": z.optional(z.string()),
"id": z.optional(z.int()),
"is_parallel_request": z.optional(z.boolean()),
"price": z.optional(z.number()),
"queue_position": z.optional(z.int()),
"scheduled_start_time": z.optional(z.string()),
"service_id": z.optional(z.int()),
"service_name": z.optional(z.string()),
"station_id": z.optional(z.int()),
"station_name": z.optional(z.string()),
"status": z.optional(z.string()),
"user_id": z.optional(z.string()),
"visit_group_id": z.optional(z.string())
    }) as unknown as z.ZodType<ModelsAppointment>